import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Pagination as PaginationBUI } from 'mage-deps/@klarna/bubble-ui'
import { withStyleSheetOverride } from '@klarna/higher-order-components'
import { translator } from 'mage-i18n'

const getDefaultStyleSheet = () => ({
  pagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
})

export function Pagination ({
  styleSheet,
  t,
  id,
  onPageChange,
  page,
  pagination: {
    count = 25,
    total = 0
  },
  scrollToTop
}) {
  const onChange = (page) => {
    onPageChange(page)
    scrollToTop && window.scrollTo(0, 0)
  }

  return count
    ? (
      <div id={id} style={styleSheet.pagination}>
        <PaginationBUI
          page={page}
          pageSize={count}
          total={total}
          ofLabel={t('core.pagination.ofLabel')}
          noResultsLabel={t('core.pagination.noResultsLabel')}
          onPageChange={onChange}
        />
      </div>
    )
    : null
}

Pagination.defaultProps = {
  pagination: {},
  scrollToTop: false
}

Pagination.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string,
  styleSheet: PropTypes.object,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pagination: PropTypes.object.isRequired,
  scrollToTop: PropTypes.bool
}

export default R.compose(
  connect(
    (state) => ({
      t: translator(state)
    })
  ),
  withStyleSheetOverride(getDefaultStyleSheet)
)(Pagination)
